module.exports = {
	"name": "@meisterplayer/plugin-htmlui",
	"version": "5.3.0",
	"description": "HTML based userinterface with preconfigured elements. Can be used to create your own userinterface",
	"main": "index.js",
	"scripts": {
		"test": "echo \"Error: no test specified\" && exit 1"
	},
	"keywords": [
		"meister",
		"plugin",
		"ui",
		"custom"
	],
	"author": "Triple",
	"license": "Apache-2.0",
	"devDependencies": {
		"gulp": "^3.9.1",
		"meister-gulp-webpack-tasks": "^1.0.7",
		"meister-js-dev": "^3.1.0",
		"yargs": "^8.0.1"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 61
// module chunks = 0